
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"13","viewBox":"0 0 13 13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-0.022)"}},[_c('g',{attrs:{"transform":"translate(0.022)"}},[_c('path',{attrs:{"d":"M6.523,0a6.5,6.5,0,1,0,6.5,6.5A6.5,6.5,0,0,0,6.523,0ZM7.654,10.938H5.4V5.527H7.654ZM6.523,4.581a1.26,1.26,0,1,1,1.26-1.26A1.26,1.26,0,0,1,6.523,4.581Z","transform":"translate(-0.022)","fill":"currentColor"}})])])])
          )
        }
      }
    